<script>
import { mapGetters } from 'vuex';
import ContactForm from './ContactForm.vue';

export default {
  components: {
    ContactForm,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    channelType: {
      type: String,
      default: '',
    },
    contact: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['cancel', 'update:show'],
  computed: {
    ...mapGetters({
      uiFlags: 'contacts/getUIFlags',
    }),
    localShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
  },

  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onSuccess() {
      this.$emit('cancel');
    },
    async onSubmit(contactItem) {
      await this.$store.dispatch('contacts/update', contactItem);
      await this.$store.dispatch(
        'contacts/fetchContactableInbox',
        this.contact.id
      );
    },
  },
};
</script>

<template>
  <woot-modal
    v-model:show="localShow"
    :on-close="onCancel"
    :close-on-backdrop="true"
    modal-type="right-aligned"
  >
    <div
      class="wlab-profile-shell wlab-profile-shell--contact-edit flex flex-col"
    >
      <div class="wlab-profile-shell__head">
        <button
          type="button"
          class="wlab-profile-shell__back"
          @click="onCancel"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            width="16"
            height="16"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m15 18-6-6 6-6"
            />
          </svg>
          Back
        </button>
        <div class="wlab-profile-shell__title">
          {{ $t('EDIT_CONTACT.TITLE') }}
        </div>
        <button
          type="button"
          class="wlab-profile-shell__close"
          aria-label="Close"
          @click="onCancel"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            width="20"
            height="20"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m6 6 12 12m0-12L6 18"
            />
          </svg>
        </button>
      </div>
      <div
        class="wlab-profile-shell__body wlab-profile-shell__body--contact-edit"
      >
        <div class="wlab-profile-section h-full min-h-0">
          <div class="wlab-profile-card h-full min-h-0">
            <ContactForm
              :contact="contact"
              :channel-type="channelType"
              :in-progress="uiFlags.isUpdating"
              :on-submit="onSubmit"
              @success="onSuccess"
              @cancel="onCancel"
            />
          </div>
        </div>
      </div>
    </div>
  </woot-modal>
</template>

<style scoped>
.wlab-profile-shell--contact-edit {
  height: min(84vh, 900px);
  max-height: min(84vh, 900px);
}

.wlab-profile-shell__body--contact-edit {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
</style>
